import { Album } from '@uploadcam/common';
import {
  AlbumItem,
  DiagnosticsError,
  DiagnosticsLoading,
  DiagnosticsReady,
  DiagnosticsStopped,
} from './diagnostics.state';

export const initStopped = (): DiagnosticsStopped => ({
  $type: 'stopped',
});

export const initLoading = (): DiagnosticsLoading => ({
  $type: 'loading',
});

export const initError = (error: unknown): DiagnosticsError => ({
  $type: 'error',
  error,
});

export const initReady = (albums: Album[]): DiagnosticsReady => ({
  $type: 'ready',
  albums: albums.map((album) => ({ data: album, isProcessing: false, isQueued: false })),
  isProcessingQueue: false,
  startedAt: new Date(),
});

export const queueAll =
  () =>
  (state: DiagnosticsReady): DiagnosticsReady => ({
    ...state,
    albums: state.albums.map((album) => ({ ...album, isQueued: true, result: undefined })),
  });

export const updateAlbumItem =
  (albumId: string, data: Partial<AlbumItem>) => (state: DiagnosticsReady) => ({
    ...state,
    albums: state.albums.map((album) =>
      album.data.id === albumId ? { ...album, ...data } : album,
    ),
  });

export const setIsProcessingQueue =
  (isProcessingQueue: boolean) =>
  (state: DiagnosticsReady): DiagnosticsReady => ({
    ...state,
    isProcessingQueue,
  });
